module.exports = __webpack_public_path__ + "static/media/add-to-cart.345bd10a.svg";